// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accordionSection":"lk9jj","accordionSectionActive":"wy77O","accordionTitleColor":"QVo3e"};